import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { BRAND } from '../lib/brand';
import { ShieldCheck } from 'lucide-react';

export default function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="datenschutz-page">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-6 w-6 text-[hsl(var(--primary))]" />
          <h1 className="font-heading font-semibold text-3xl sm:text-4xl text-[hsl(var(--primary))]">Datenschutzerklärung</h1>
        </div>
        <p className="text-sm text-slate-600 mt-1">Information gemäß DSGVO (EU) 2016/679 und österreichischem DSG.</p>

        <Card className="mt-6 rounded-2xl border-slate-200">
          <CardContent className="p-6 space-y-5 text-sm text-slate-800 leading-relaxed">

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">1. Verantwortlicher</h2>
              <p className="mt-2">
                Rezart Gashi (Einzelunternehmer), Draschestraße 75, 1230 Wien, Österreich.<br />
                Telefon: {BRAND.phoneDisplay} · E-Mail: <a className="text-[hsl(var(--primary))] hover:underline" href="mailto:info@unfallheld.com">info@unfallheld.com</a><br />
                UID: ATU76441646
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">2. Allgemeines zur Datenverarbeitung</h2>
              <p className="mt-2">
                Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der gesetzlichen Bestimmungen (insbesondere
                DSGVO und DSG). Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder
                identifizierbare natürliche Person beziehen.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">3. Welche Daten wir verarbeiten</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li><strong>Kontaktdaten:</strong> Vor- und Nachname, E-Mail, Telefonnummer.</li>
                <li><strong>Falldaten:</strong> Unfallhergang (Text/Sprache), Datum, Uhrzeit, Standort (GPS, optional), Beteiligte.</li>
                <li><strong>Fahrzeugdaten:</strong> Marke, Modell, Kennzeichen, FIN, Erstzulassung, Versicherung.</li>
                <li><strong>Dokumente &amp; Fotos:</strong> Zulassungsschein, Führerschein, Versicherungskarte, Unfallfotos.</li>
                <li><strong>Technische Daten:</strong> IP-Adresse, Browser, Zeitstempel (Server-Logs).</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">4. Zwecke und Rechtsgrundlagen</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li><strong>Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO):</strong> Abwicklung Ihrer Schadensmeldung, Kommunikation mit Versicherung, Gutachter und Werkstatt.</li>
                <li><strong>Rechtliche Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO):</strong> Aufbewahrungspflichten (z.B. UGB, BAO).</li>
                <li><strong>Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO):</strong> Betrieb &amp; Sicherheit der Plattform, KI-gestützte Ersteinschätzung.</li>
                <li><strong>Einwilligung (Art. 6 Abs. 1 lit. a DSGVO):</strong> Standortübermittlung, optionale Sprachaufnahme, Newsletter (falls angeboten).</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">5. KI-Verarbeitung</h2>
              <p className="mt-2">
                Zur Erstellung einer Ersteinschätzung des Schadens, zur Strukturierung Ihrer Sprachaufnahme und zur
                Texterkennung Ihrer Dokumente nutzen wir KI-Modelle (Claude Sonnet 4.5 von Anthropic) über einen DSGVO-konformen
                EU-Verarbeitungsweg. Die Daten werden ausschließlich zur Erfüllung Ihrer Anfrage verarbeitet und nicht zum
                Training öffentlicher Modelle verwendet.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">6. Empfänger der Daten</h2>
              <p className="mt-2">
                Eine Übermittlung erfolgt nur, soweit zur Abwicklung erforderlich, an: Versicherungen, Kfz-Gutachter,
                Werkstätten, Behörden (auf Anforderung) sowie technische Auftragsverarbeiter (Hosting, KI-Provider).
                Mit allen Auftragsverarbeitern bestehen entsprechende Verträge gemäß Art. 28 DSGVO.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">7. Speicherdauer</h2>
              <p className="mt-2">
                Wir speichern personenbezogene Daten nur so lange, wie es zur Erfüllung der Zwecke notwendig ist oder gesetzliche
                Aufbewahrungsfristen (z.B. 7 Jahre gemäß BAO) dies vorschreiben. Danach werden die Daten gelöscht oder anonymisiert.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">8. Ihre Rechte</h2>
              <p className="mt-2">Sie haben jederzeit das Recht auf:</p>
              <ul className="mt-1 list-disc pl-5 space-y-1">
                <li>Auskunft (Art. 15 DSGVO)</li>
                <li>Berichtigung (Art. 16 DSGVO)</li>
                <li>Löschung (Art. 17 DSGVO)</li>
                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Widerspruch (Art. 21 DSGVO)</li>
                <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
              </ul>
              <p className="mt-2">
                Zur Ausübung Ihrer Rechte genügt eine formlose E-Mail an{' '}
                <a className="text-[hsl(var(--primary))] hover:underline" href="mailto:info@unfallheld.com">info@unfallheld.com</a>.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">9. Beschwerderecht</h2>
              <p className="mt-2">
                Sie haben das Recht, sich bei der österreichischen Datenschutzbehörde zu beschweren:<br />
                Österreichische Datenschutzbehörde, Barichgasse 40-42, 1030 Wien · <a className="text-[hsl(var(--primary))] hover:underline" href="https://www.dsb.gv.at" target="_blank" rel="noreferrer">www.dsb.gv.at</a>
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">10. Cookies &amp; Tracking</h2>
              <p className="mt-2">
                Diese Website verwendet ausschließlich technisch notwendige Cookies (z.B. für Login/Sitzung). Es findet keine
                Verhaltensanalyse statt. Soweit künftig Tracking-Cookies eingesetzt werden, wird die Verarbeitung erst nach
                Ihrer ausdrücklichen Einwilligung erfolgen.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">11. Änderungen</h2>
              <p className="mt-2">
                Diese Datenschutzerklärung kann an geänderte rechtliche oder technische Gegebenheiten angepasst werden.
                Es gilt jeweils die aktuelle, auf dieser Seite veröffentlichte Fassung.
              </p>
            </section>

            <p className="text-xs text-slate-500 pt-4 border-t border-slate-100">
              Stand: {new Date().toLocaleDateString('de-AT', { year: 'numeric', month: 'long' })}.
              Dies ist eine Standard-Vorlage und ersetzt keine individuelle Rechtsberatung.
            </p>
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
